import React from 'react';

const CowFeedHistory = ({ records }) => {
    if (records.length === 0) return <p className="text-center text-gray-500 py-4">No feed records found for this animal.</p>;
    
    return (
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Feed Type</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Quantity (kg)</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Price/kg (₹)</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Total Cost (₹)</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {records.map(rec => (
                        <tr key={rec.id}>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{new Date(rec.date + 'T00:00:00').toLocaleDateString()}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{rec.feedItemName}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{rec.quantity.toFixed(2)}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{rec.unitPrice ? rec.unitPrice.toFixed(2) : 'N/A'}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{rec.cost.toFixed(2)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CowFeedHistory;